import { lazyWithRetry } from "@js/utils/lazy-with-retry";

export const CommonLexicalEditorLazy = lazyWithRetry(async () => {
  const module = await import(
    /* webpackChunkName: "lexical-editor" */ "@js/components/rich-text-editor/common-editor/common-editor"
  );
  return { default: module.CommonLexicalEditor };
});
